import { axios, axiosWithoutHeaders } from "../../cores/axiosWrapper";

const AssetApi = {
    getStatus,
    activate,
    inactivate,
    createAutoCaption,
    createAssetTagAPI,
    deleteAssetTagAPI,
    putArchiveAPI,
    anlayzeAssetAPI,
    getAssetAnalysisObjectsAPI,
    getAssetAnalysisObjectsFromSharedAPI,
    getAssetAnalysisObjectDetailsAPI,
    getAssetAnalysisStatusAPI,
    getAssetAPI,
    getAssetsAPI,
    deleteAssetAPI,
    createAssetElementAPI,
    bulkCreateAssetElementsAPI,
    updateAssetElementAPI,
    deleteAssetElementAPI,
    updateAssetAPI,
    updateAssetOwnerAPI,
    getRelatedVideosAPI,
    getUploadUrlAPI,
    requestAssetElementsDownloadUrlApi,
    getAssetElementsDownloadUrlStatusApi,
    requestAssetsDownloadUrlApi,
    getAssetsDownloadUrlStatusApi,
    getAssetRelatedContentsAPI,
};

export function getStatus(stageId, apiEndpoint, projectId, assetId) {
    const response = axios.get(`${apiEndpoint}/assets/${assetId}/status`, {
        headers: {
            stageId,
            projectId,
        },
    });
    return response;
}

export function activate(stageId, apiEndpoint, projectId, id, version, customErrorMessage) {
    return axios.put(`${apiEndpoint}/assets/${id}/activate`, null, {
        params: {
            version,
        },
        headers: {
            stageId,
            projectId,
            "Content-Type": "application/json",
        },
        customErrorMessage,
    });
}

export function inactivate(stageId, apiEndpoint, projectId, id, version, customErrorMessage) {
    return axios.put(`${apiEndpoint}/assets/${id}/inactivate`, null, {
        params: {
            version,
        },
        headers: {
            stageId,
            projectId,
            "Content-Type": "application/json",
        },
        customErrorMessage,
    });
}

export function createAutoCaption(stageId, apiEndpoint, projectId, id, data) {
    return axios.put(`${apiEndpoint}/assets/${id}/transcribe`, data, {
        headers: {
            stageId,
            projectId,
            "Content-Type": "application/json",
        },
    });
}

export function createAssetTagAPI(stageId, apiEndpoint, projectId, assetId, value) {
    const data = {
        value,
    };
    return axios.put(`${apiEndpoint}/assets/${assetId}/hashtag`, data, {
        headers: {
            stageId,
            projectId,
        },
    });
}

export function deleteAssetTagAPI(stageId, apiEndpoint, projectId, assetId, value) {
    return axios.delete(`${apiEndpoint}/assets/${assetId}/hashtag`, {
        headers: {
            stageId,
            projectId,
        },
        params: {
            value,
        },
    });
}

export function putArchiveAPI(apiEndpoint, projectId, assetId, data) {
    return axios.put(`${apiEndpoint}/assets/${assetId}/archive`, data, {
        headers: {
            projectId,
            "Content-Type": "application/json",
        },
    });
}

export async function anlayzeAssetAPI(stageId, apiEndpoint, projectId, assetId, input, types, resourceToken) {
    // mp4여야만 제대로 동작 한다.
    // 필요하면 mp4인지 유효성 체크를 한다.
    // 현재는 API 콜은 성공하고 Status 가져오는 부분에서 실패 처리 된다.

    const s3Object = input.toS3Object();
    const video = {
        s3Object: {
            bucket: s3Object.bucket,
            name: s3Object.key,
        },
    };
    let faceSearch = {};
    if (types.filter((t) => t === "FaceSearch").length > 0) {
        const faceCollectionsResult = await axios.get(`${apiEndpoint}/ai/analysis/face-collections`, {
            headers: {
                stageId,
                projectId,
            },
            params: {
                offset: 0,
                limit: 1,
            },
        });
        if (
            faceCollectionsResult &&
            faceCollectionsResult.data &&
            faceCollectionsResult.data.faceCollections &&
            faceCollectionsResult.data.faceCollections.length > 0
        ) {
            faceSearch = {
                collectionId: faceCollectionsResult.data.faceCollections[0].name,
            };
        } else {
            throw new Error("Collection is not registered. Please contact to admin.");
        }
    }
    const data = {
        confidence: 80,
        faceSearch,
        types,
        video,
    };
    return axios.post(`${apiEndpoint}/assets/${assetId}/analysis`, data, {
        headers: {
            stageId,
            projectId,
        },
    });
}

export function createAnalysisJobAPI(apiEndpoint, projectId, data) {
    return axios.post(`${apiEndpoint}/ai/analysis`, data, {
        headers: {
            projectId,
        },
    });
}

export function getAssetAnalysisObjectsAPI(
    stageId,
    apiEndpoint,
    projectId,
    assetId,
    type,
    offset,
    limit,
    resourceToken,
) {
    return axios.get(`${apiEndpoint}/assets/${assetId}/analysis/objects`, {
        headers: {
            stageId,
            projectId,
            "x-mzc-cp-resource-token": resourceToken,
        },
        params: {
            offset,
            limit,
            type: type,
        },
    });
}

export function getAssetAnalysisObjectsFromSharedAPI(
    stageId,
    apiEndpoint,
    projectId,
    assetId,
    type,
    offset,
    limit,
    resourceToken,
) {
    return axios.get(`${apiEndpoint}/v2/shared-assets/proxy/assets/${assetId}/analysis/objects`, {
        headers: {
            stageId,
            projectId,
            "x-mzc-cp-resource-token": resourceToken,
        },
        params: {
            offset,
            limit,
            type: type,
        },
    });
}

export function getAssetAnalysisObjectDetailsAPI({
    stageId,
    apiEndpoint,
    projectId,
    assetId,
    type,
    key,
    value,
    nextToken,
}) {
    const params = {
        type,
        key,
        value,
        groupBy: "TIMESTAMP",
    };
    if (nextToken) params.nextToken = nextToken;

    return axios.get(`${apiEndpoint}/assets/${assetId}/analysis/object-details`, {
        headers: {
            stageId,
            projectId,
        },
        params,
    });
}

export function getAssetAnalysisStatusAPI(stageId, apiEndpoint, projectId, assetId, resourceToken) {
    return axios.get(`${apiEndpoint}/assets/${assetId}/analysis/status`, {
        headers: {
            stageId,
            projectId,
            "x-mzc-cp-resource-token": resourceToken,
        },
    });
}

export function getAssetAPI(stageId, apiEndpoint, projectId, id, data = {}) {
    let params = {
        ...data,
        generateAccessUrl: true,
    };
    return axios.get(`${apiEndpoint}/assets/${id}`, {
        headers: {
            stageId,
            projectId,
        },
        params,
    });
}

export function getAssetsAPI(stageId, apiEndpoint, projectId, query, resourceToken) {
    let queries = {
        ...query,
        offset: 0,
        limit: 99999,
        generateAccessUrl: true,
    };
    return axios.get(`${apiEndpoint}/assets`, {
        params: queries,
        headers: {
            stageId,
            projectId,
            "x-mzc-cp-resource-token": resourceToken,
        },
    });
}

export function deleteAssetAPI(stageId, apiEndpoint, projectId, id, version) {
    return axios.delete(`${apiEndpoint}/assets/${id}`, {
        params: {
            version,
            deleteAIJobs: true,
        },
        headers: {
            stageId,
            projectId,
        },
    });
}

export function createAssetElementAPI(stageId, apiEndpoint, projectId, id, version, data) {
    return axios.post(`${apiEndpoint}/assets/${id}/elements`, data, {
        params: {
            version,
        },
        headers: {
            stageId,
            projectId,
        },
    });
}

export function bulkCreateAssetElementsAPI(stageId, stageVersion, apiEndpoint, projectId, id, version, data) {
    let headers = {
        stageId,
        projectId,
    };

    data = Buffer.from(encodeURIComponent(JSON.stringify(data))).toString("base64");
    headers = {
        ...headers,
        "x-mzc-content-encoding": "base64",
    };

    return axios.post(`${apiEndpoint}/assets/${id}/elements/bulk`, data, {
        params: {
            version,
        },
        headers,
    });
}

export function updateAssetElementAPI(stageId, apiEndpoint, projectId, id, version, elementId, data) {
    return axios.patch(`${apiEndpoint}/assets/${id}/elements/${elementId}`, data, {
        params: {
            version,
            generateAccessUrl: true,
        },
        headers: {
            stageId,
            projectId,
        },
    });
}

export function deleteAssetElementAPI(stageId, apiEndpoint, projectId, id, version, elementId) {
    return axios.delete(`${apiEndpoint}/assets/${id}/elements/${elementId}`, {
        params: {
            version,
        },
        headers: {
            stageId,
            projectId,
        },
    });
}

// TODO : https://mzdevs.atlassian.net/browse/CM-3857
export function updateAssetAPI(stageId, apiEndpoint, projectId, id, version, updateTotalSize, data) {
    if (data.categories && data.categories.length === 0) {
        data.categories = [{}];
    }

    if (data.attributions && data.attributions.length === 0) {
        data.attributions = [{}];
    }

    if (data.tags && data.tags.length === 0) {
        data.tags = [{}];
    }

    return axios.patch(`${apiEndpoint}/assets/${id}`, data, {
        params: {
            version,
            updateTotalSize,
            generateAccessUrl: true,
        },
        headers: {
            stageId,
            projectId,
        },
    });
}

export function updateAssetOwnerAPI(stageId, apiEndpoint, projectId, id, version, data) {
    return axios.put(`${apiEndpoint}/assets/${id}/owner`, data, {
        params: {
            version,
            generateAccessUrl: true,
        },
        headers: {
            stageId,
            projectId,
        },
    });
}

export function getRelatedVideosAPI(stageId, apiEndpoint, projectId, id, resourceToken) {
    return axios.get(`${apiEndpoint}/videos`, {
        params: {
            assetId: id,
        },
        headers: {
            stageId,
            projectId,
            "x-mzc-cp-resource-token": resourceToken,
        },
    });
}

export function getUploadUrlAPI(stageId, apiEndpoint, projectId, assetId, params) {
    return axios.get(`${apiEndpoint}/assets/${assetId}/upload-url`, {
        headers: {
            stageId,
            projectId,
        },
        params,
    });
}

export function requestAssetElementsDownloadUrlApi(
    stageId,
    apiEndpoint,
    projectId,
    assetId,
    elementIds,
    resourceToken,
) {
    return axios.post(
        `${apiEndpoint}/assets/${assetId}/elements/download`,
        {
            elementIds,
        },
        {
            headers: {
                stageId,
                projectId,
                "x-mzc-cp-resource-token": resourceToken,
            },
        },
    );
}

export function getAssetElementsDownloadUrlStatusApi(
    stageId,
    apiEndpoint,
    projectId,
    assetId,
    downloadId,
    resourceToken,
) {
    return axios.get(`${apiEndpoint}/assets/${assetId}/elements/download`, {
        headers: {
            stageId,
            projectId,
            "x-mzc-cp-resource-token": resourceToken,
        },
        params: {
            downloadId,
        },
    });
}

export function requestAssetsDownloadUrlApi(stageId, apiEndpoint, projectId, assetIds, resourceToken) {
    return axios.post(
        `${apiEndpoint}/assets/download`,
        {
            assetIds,
        },
        {
            headers: {
                stageId,
                projectId,
                "x-mzc-cp-resource-token": resourceToken,
            },
        },
    );
}

export function getAssetsDownloadUrlStatusApi(stageId, apiEndpoint, projectId, downloadId, resourceToken) {
    return axios.get(`${apiEndpoint}/assets/download`, {
        headers: {
            stageId,
            projectId,
            "x-mzc-cp-resource-token": resourceToken,
        },
        params: {
            downloadId,
        },
    });
}

export function getAssetElementVersionsAPI(stageId, apiEndpoint, projectId, id, elementId, params, resourceToken) {
    return axios.get(`${apiEndpoint}/assets/${id}/elements/${elementId}/versions`, {
        params,
        headers: {
            stageId,
            projectId,
            "x-mzc-cp-resource-token": resourceToken,
        },
    });
}

export function getDictationVocabulariesAPI(stageId, apiEndpoint, projectId, params) {
    return axios.get(`${apiEndpoint}/dictation-vocabularies`, {
        params,
        headers: {
            stageId,
            projectId,
        },
    });
}

export function createAutoCaptionsAPI(stageId, apiEndpoint, projectId, data) {
    return axios.post(`${apiEndpoint}/ai/captions`, data, {
        headers: {
            stageId,
            projectId,
        },
    });
}

export function getAiCaptionsAPI(stageId, apiEndpoint, projectId, params) {
    return axios.get(`${apiEndpoint}/ai/captions`, {
        params,
        headers: {
            stageId,
            projectId,
        },
    });
}

export function getAiAnalysisAPI(stageId, apiEndpoint, projectId, params) {
    return axios.get(`${apiEndpoint}/ai/analysis`, {
        params,
        headers: {
            stageId,
            projectId,
        },
    });
}

/**
 * AI 분석 결과 조회에 쓰는 최소 신뢰도.
 *
 * 분석 '요청' 시점의 confidence(분석 생성 · 관리자 설정)와는 별개로, 조회 결과에서 오인식을 걸러낸다.
 * 모든 엔진에 거는 값이 아니다 — 영상 편집으로 넘길 수 있는 엔진에만 적용한다.
 * STT/OCR 계열은 인식 신뢰도가 90 미만인 발화도 자막으로 보여줘야 해서 대상에서 뺀다.
 * 적용 대상 판정은 routes/ai-analysis/constants.js 의 getAnalysisConfidenceParams 참고.
 */
export const AI_ANALYSIS_MIN_CONFIDENCE = 90;

export function getAiAnalysisResultsAPI(stageId, apiEndpoint, projectId, analysisId, params) {
    return axios.get(`${apiEndpoint}/ai/analysis/${analysisId}/results`, {
        params,
        headers: {
            stageId,
            projectId,
        },
    });
}

export function getAiAnalysisSummariesAPI(stageId, apiEndpoint, projectId, analysisId, params) {
    return axios.get(`${apiEndpoint}/ai/analysis/${analysisId}/summaries`, {
        params,
        headers: {
            stageId,
            projectId,
        },
    });
}

export function getDownloadAiAnalysisLinksAPI(stageId, apiEndpoint, projectId, data) {
    return axios.put(`${apiEndpoint}/ai/analysis:download-links`, data, {
        headers: {
            stageId,
            projectId,
        },
    });
}

export function getAiOriginalResultsAPI(stageId, apiEndpoint, projectId, analysisId, params) {
    return axios.get(`${apiEndpoint}/ai/analysis/${analysisId}/original-results`, {
        params,
        headers: {
            stageId,
            projectId,
        },
    });
}

export function getAiOriginalResultAPI(stageId, apiEndpoint, projectId, analysisId, resultId) {
    return axios.get(`${apiEndpoint}/ai/analysis/${analysisId}/original-results/${resultId}`, {
        headers: {
            stageId,
            projectId,
        },
    });
}

/**
 * 원본 분석 결과 JSON 을 accessUrl 로 직접 내려받는다.
 *
 * 1.0.154 부터 Transcribe 는 결과가 큰 경우 API 응답 크기 제한(Response size limit exceeded)에 걸리므로
 * 결과 본문을 응답에 담지 않고 accessUrl 링크만 내려준다.
 *
 * accessUrl 은 자사 API 가 아닌 외부(프리사인) 링크이므로
 * - 앱 기본 헤더(stageId/projectId 등)를 붙이지 않도록 axiosWithoutHeaders 를 쓰고,
 * - 자사 API 응답을 전제로 동작하는 전역 응답 인터셉터를 타지 않도록 customErrorMessage 로 우회한다.
 *
 * @param {string} accessUrl 분석 결과 JSON 접근 URL
 * @returns {Promise} 분석 결과 JSON 응답
 */
export function getAiOriginalResultDataAPI(accessUrl) {
    return axiosWithoutHeaders.get(accessUrl, { customErrorMessage: true });
}

export function copyAssetAPI(stageId, apiEndpoint, projectId, data) {
    return axios.post(`${apiEndpoint}/assets:copy`, data, {
        headers: {
            stageId,
            projectId,
        },
    });
}

/**
 *
 * @param {string} stageId stage id
 * @param {string} apiEndpoint media api endpoint
 * @param {string} projectId project id
 * @param {string} id asset id
 * @param {string} version asset version
 * @param {string} [resourceToken] shared asset resource token
 * @param {array} [elementids] elementIds
 * @returns
 */
export function getAssetRelatedContentsAPI(stageId, apiEndpoint, projectId, id, version, resourceToken, elementIds) {
    const headers = {
        stageId,
        projectId,
    };
    if (resourceToken) headers["x-mzc-cp-resource-token"] = resourceToken;
    const params = { elementIds: elementIds && elementIds.join(",") };
    return axios.get(`${apiEndpoint}/assets/${id}/related-contents`, {
        params,
        headers,
    });
}

export const getAssetLinkedAssetsAPI = async (apiEndpoint, projectId, assetId, params) => {
    return axios.get(`${apiEndpoint}/assets/${assetId}/linked-assets`, {
        params,
        headers: {
            projectId,
        },
    });
};

export const addAssetLinkedAssetsAPI = async (apiEndpoint, projectId, assetId, data) => {
    return axios.post(`${apiEndpoint}/assets/${assetId}/linked-assets`, data, { headers: { projectId } });
};

export const removeAssetLinkedAssetsAPI = async (apiEndpoint, projectId, assetId, linkedAssetId) => {
    return axios.delete(`${apiEndpoint}/assets/${assetId}/linked-assets/${linkedAssetId}`, { headers: { projectId } });
};

export const createPreviewResourcePresignUrlAPI = async (apiEndpoint, stageVersion, stageId, projectId, params) => {
    let headers = { stageId };
    if (projectId) headers.projectId = projectId;

    return axios.post(`${apiEndpoint}/preview-resources/url`, params, { headers });
};

export const updatePreviewResourcesAPI = async (apiEndpoint, stageVersion, stageId, projectId, params) => {
    let headers = { stageId, projectId };

    return axios.post(`${apiEndpoint}/preview-resources:actions`, params, { headers });
};

export const captureVideoImageAPI = async (apiEndpoint, stageId, projectId, assetId, params) => {
    let headers = { stageId, projectId };

    return axios.post(`${apiEndpoint}/assets/${assetId}/capture`, params, { headers });
};

export const getAssetCustomMetadataAPI = async (apiEndpoint, projectId, assetId, contentId, customErrorMessage) => {
    let headers = { projectId };
    return axios.get(`${apiEndpoint}/assets/${assetId}/contents/${contentId}`, {
        headers,
        customErrorMessage,
    });
};

export const createOwnerLockAPI = async (apiEndpoint, stageId, projectId, params) => {
    let headers = { stageId, projectId };

    return axios.post(`${apiEndpoint}/assets:owner-lock`, params, { headers });
};

export const createOwnerUnLockAPI = async (apiEndpoint, stageId, projectId, params) => {
    let headers = { stageId, projectId };

    return axios.post(`${apiEndpoint}/assets:owner-unlock`, params, { headers });
};

export function createShortformAPI(stageId, apiEndpoint, projectId, assetId, data) {
    return axios.post(`${apiEndpoint}/assets/${assetId}/shortforms`, data, {
        headers: {
            stageId,
            projectId,
        },
    });
}

export const getAssetPublicUrlsAPI = async (apiEndpoint, projectId, assetId) => {
    return axios.get(`${apiEndpoint}/assets/${assetId}/public-urls`, { headers: { projectId } });
};

export const getAssetPublicUrlAPI = async (apiEndpoint, projectId, assetId, publicUrlId) => {
    return axios.get(`${apiEndpoint}/assets/${assetId}/public-urls/${publicUrlId}`, { headers: { projectId } });
};

/*
 * 아래 게시·해제 3종은 `customErrorMessage: true`로 인터셉터의 공통 에러 토스트([Error:400] …)를 끈다.
 * 유일한 호출부인 공개 URL 모달이 실패를 자체 문구로 알리므로, 끄지 않으면 토스트가 두 개 뜬다.
 * 조회(getAssetPublicUrls·getAssetPublicUrl)는 인라인 에러 노티스가 따로 있어 대상이 아니다.
 */

// data를 생략하거나 elementIds가 없으면 자산의 모든 element를 게시한다.
export const createAssetPublicUrlAPI = async (apiEndpoint, projectId, assetId, data) => {
    return axios.post(`${apiEndpoint}/assets/${assetId}/public-urls`, data, {
        headers: { projectId },
        customErrorMessage: true,
    });
};

export const deleteAssetPublicUrlsAPI = async (apiEndpoint, projectId, assetId) => {
    return axios.delete(`${apiEndpoint}/assets/${assetId}/public-urls`, {
        headers: { projectId },
        customErrorMessage: true,
    });
};

export const deleteAssetPublicUrlAPI = async (apiEndpoint, projectId, assetId, publicUrlId) => {
    return axios.delete(`${apiEndpoint}/assets/${assetId}/public-urls/${publicUrlId}`, {
        headers: { projectId },
        customErrorMessage: true,
    });
};

/*
 * 공개 URL 통계 2종.
 *
 * ⚠️ 경로가 `/assets/{assetId}/...`가 아니다. 통계는 별도 리소스(`/public-url-statistics`)로 분리돼 있어
 *    자산 ID가 경로 뒤쪽에 온다. 게시(public-urls)와 다른 API라 응답에도 URL·게시 상태가 없다.
 *
 * 공통 규약(mzc-dam-docs `products/dam/api/design/public-url-statistics.yml`)
 *   - startDate/endDate: `YYYY-MM-DD`, UTC 0 기준이며 endDate는 **포함**. 간격이 92일을 넘으면 400.
 *   - granularity: `day`(기본) | `hour`. 시계열 집계 단위이며 차원(국가·리퍼러) 분해와는 무관하다.
 *   - 통계가 없는 기간·자산은 404가 아니라 **0 합계로 200**이 온다. 이때 배열 필드는 비거나 아예 빠지므로
 *     소비하는 쪽이 `?? []`로 받아야 한다(자산 조회에서 `elements` 누락 확인).
 *
 * 두 API 모두 `customErrorMessage: true`로 인터셉터 공통 에러 토스트를 끈다 — 통계 화면이 오류 화면과
 * 재조회 실패 막대를 직접 그리므로, 켜 두면 같은 실패를 두 곳이 말한다.
 */

/**
 * 자산 단위 공개 URL 통계.
 * @param {object} [params] - { startDate, endDate, granularity }
 * @returns {Promise} { summary, timeSeries, elements, countries, referers, userAgents }
 */
export const getAssetPublicUrlStatisticsAPI = async (apiEndpoint, projectId, assetId, params) => {
    return axios.get(`${apiEndpoint}/public-url-statistics/assets/${assetId}`, {
        params,
        headers: { projectId },
        customErrorMessage: true,
    });
};

/**
 * 엘리먼트 단위 공개 URL 통계. 개별 파일로 게시된 element에만 의미가 있다 —
 * HLS/DASH 자산은 요청이 자산 단위로 귀속돼 element 통계가 없으므로 자산 조회를 써야 한다.
 * @param {object} [params] - { startDate, endDate, granularity }
 * @returns {Promise} { summary, timeSeries, countries, referers, userAgents } (elements 없음)
 */
export const getAssetElementPublicUrlStatisticsAPI = async (
    apiEndpoint,
    projectId,
    assetId,
    elementId,
    params,
) => {
    return axios.get(`${apiEndpoint}/public-url-statistics/assets/${assetId}/elements/${elementId}`, {
        params,
        headers: { projectId },
        customErrorMessage: true,
    });
};

export default AssetApi;
